import jQuery from 'jquery';

window.$ = jQuery;
window.jQuery = jQuery;
globalThis.$ = jQuery;
globalThis.jQuery = jQuery;

import initSelect2 from 'javascript/vendor/select2/select2-full.js';
initSelect2($);

import initDatetimepicker from 'javascript/vendor/jquery.xdan.datetimepicker/jquery.xdan.datetimepicker.full';
initDatetimepicker($);

export default jQuery;
